module.exports = __webpack_public_path__ + "static/media/hotelBookingHero.6865260f.png";